import { useState, useEffect } from 'react'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { useToast } from 'tennders-common/hooks/useToast'

const useUpdateBookRate = ({ transaction, setEditable }) => {
  const [saving, setSaving] = useState(false)
  const [inputPrice, setInputPrice] = useState(transaction?.matchedTruck?.bookRate)
  const { toastError } = useToast()
  useEffect(() => {
    if (transaction?.matchedTruck?.bookRate !== undefined) {
      setInputPrice(prev => (prev === undefined ? transaction?.matchedTruck?.bookRate : prev))
    }
  }, [transaction?.matchedTruck?.bookRate])
  const { editTransaction } = useTransactions()

  const updatePrice = async (type: string) => {
    setSaving(true)
    const result = await editTransaction(transaction?.id,
      { bookRate: parseFloat(inputPrice), bookType: type })
    setEditable(false)
    setSaving(false)
    if (result.error) {
      toastError(result.error)
      return false
    }

    return true
  }

  return {
    saving,
    inputPrice,
    updatePrice,
    setInputPrice
  }
}

export default useUpdateBookRate
